import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StyledModal,CalendarHeader,Border, ConfirmPlanModalBody} from './styles';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { CompanyDepartmentAPI, CompanyLocationAPI, PostCompanyAdminRewardTierConfig } from '../../../redux/constants/apiConstants';
import CommonDropdown from '../../common/CommonDropDown/CommonDropdown';
import { StyledLabel } from '../../CreateEvent/style';
import { t } from 'i18next';
import { RadioGroup, RadioLabel } from '../../EditWellnessJourney/styles';
import RadioButtonNew from '../../ContentV2/CustomRadioButtonNew';
import { AdminCloseIcon } from '../../../utils/icons';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

const BadgesArray = [{label:"All Badges",value:'badges'},{label:"Bronze",value:'bronze'},{label:"Silver",value:'silver'},{label:"Gold",value:'gold'},{label:"Platinum",value:'platinum'}];


const RewardReportModal = ({
  show,
  icon,
  title,
  onCancel,
  modalWidth = "500px",
  modalHeight,
  companyInfo,
  onClose
  //   history,
}) =>{

  const [loading, setLoading] = useState(false);
  const [selectedDepartment, setSelectedDepartment]  = useState(false);
  const [selectedLocation, setSelectedLocation]  = useState(false);
  const [selectedBadge, setSelectedBadge]  = useState(BadgesArray?.[0]);

  const[departmentDropdownOpen,setDepartmentDropdownOpen] = useState(false);
  const[locationDropdownOpen,setLocationDropdownOpen] = useState(false);
  const[badgeDropdownOpen,setBadgeDropdownOpen] = useState(false);
  const[selectedDuration, setSelectedDuration] = useState('year');

  const [locationData, setLocationData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);

  useEffect(()=>{
    fetchLocation(companyInfo.id);
    fetchDepartment(companyInfo.id)
  },[])


  const fetchLocation = async(companyId) => {
    let apiUrl = `${CompanyLocationAPI}?company_id=${companyId}`;
    try {
      const res = await fetchApi(apiUrl,"GET");
      if(res?.data?.message){
        toast.error(res.data.message)
      }else{
        setLocationData(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }};

  const fetchDepartment = async(companyId) => {
    let apiUrl = `${CompanyDepartmentAPI}?company_id=${companyId}`;
    try {
      const res = await fetchApi(apiUrl,"GET");
      if(res?.data?.message){
        toast.error(res.data.message)
      }else{
        setDepartmentData(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }};

  const postCompanyRewardTier = async() =>{
    setLoading(true);
    const payload = {company_id:companyInfo.id}


    try {
      const companyRewardsData = await fetchApi(PostCompanyAdminRewardTierConfig , "POST",payload);
      if(companyRewardsData?.status === 'success'){

        onCancel();
      }else{
        toast.error(companyRewardsData?.data?.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }

  const onDepartmentChange = (item)=>{
    window.console.log("item",item);
    setSelectedDepartment(item);
  }

  const onBadgeChange = (item)=>{
    window.console.log("item",item);
    setSelectedBadge(item);
  }

  const onLocationChange = (item)=>{
    window.console.log("item",item);
    setSelectedLocation(item);
  }

  

  const SelectPointTierLevels = () => {
    window.console.log("hihi");
    
    return (
      <>

        <div className="formBody" style={{width:'100%'}}>
          <StyledLabel margin='20px' marginb='12px' style={{float:'unset'}}>{t("Select Date Range")}?{<span>*</span>}</StyledLabel>
          <RadioGroup>
            <RadioLabel onClick={() => setSelectedDuration('year')}>
              <RadioButtonNew
                isChecked={selectedDuration === 'year'}
                handler={() => setSelectedDuration(1)}
                value={"yesr"}
                background={"#85c0ea"}
              />
              {t("This Year")}
            </RadioLabel>
  
            <RadioLabel onClick={() => setSelectedDuration(2)}>
              <RadioButtonNew
                isChecked={selectedDuration === 2}
                handler={() => setSelectedDuration(2)}
                // value={'2'}
                background={"#85c0ea"}
              />
              {t("This Month")}
            </RadioLabel>
  
            <RadioLabel onClick={() => setSelectedDuration(3)}>
              <RadioButtonNew
                isChecked={selectedDuration === 3}
                handler={() => setSelectedDuration(3)}
                // value={'3'}
                background={"#85c0ea"}
              />
              {t("This Quarter")}
            </RadioLabel>
          </RadioGroup>
        </div>

        <CommonDropdown
          tileContainerStyle={{ width: "100%", padding:"0px 0px 0px 0px", margin: "20px 0 0 0" }}
          dropdownStyle={{ top: "95px" }}
          labelText={"Badges"}
          isRequired={true}
          dropdownOpen={badgeDropdownOpen}
          placeholder={"Select Badge"}
          title={
            selectedBadge?.label
          }
          id="dropdown-recurring"
          onClick={() => setBadgeDropdownOpen(!badgeDropdownOpen)}
          data={BadgesArray}
          active={selectedBadge?.badge}
          onSelectParameter={["label", "value"]}
          // valueString={"Points"}
          itemValue={true}
          valueIndex={0}
          labelMargin={"0px"}
          onSelect={onBadgeChange}
          dropIcon={true}
        />

        <CommonDropdown
          tileContainerStyle={{ width: "100%", padding:"0px 0px 0px 0px", margin: "20px 0 0 0" }}
          dropdownStyle={{ top: "95px" }}
          labelText={"Department"}
          isRequired={true}
          dropdownOpen={departmentDropdownOpen}
          placeholder={"Select Department"}
          title={
            selectedDepartment?.department
          }
          id="dropdown-recurring"
          onClick={() => setDepartmentDropdownOpen(!departmentDropdownOpen)}
          data={departmentData}
          active={selectedDepartment?.department}
          onSelectParameter={["department", "id"]}
          // valueString={"Points"}
          itemValue={true}
          valueIndex={0}
          labelMargin={"0px"}
          onSelect={onDepartmentChange}
          dropIcon={true}
        />

        <CommonDropdown
          tileContainerStyle={{ width: "100%", padding:"0px 0px 20px 0px", margin: "20px 0 0 0" }}
          dropdownStyle={{ top: "95px" }}
          labelText={"Location"}
          isRequired={true}
          dropdownOpen={badgeDropdownOpen}
          placeholder={"Select Location"}
          title={
            selectedLocation?.location
          }
          id="dropdown-recurring"
          onClick={() => setLocationDropdownOpen(!locationDropdownOpen)}
          data={locationData}
          active={selectedLocation?.location}
          onSelectParameter={["location", "id"]}
          // valueString={"Points"}
          itemValue={true}
          valueIndex={0}
          labelMargin={"0px"}
          onSelect={onLocationChange}
          dropIcon={true}
        />        

        
      </>
    );
  };
      
    
  return(
    <StyledModal show={show} width={modalWidth} height={modalHeight}>
      <div className="modal-content-padding">
        <CalendarHeader style={{marginBottom:'0px'}}>
          <div className="left-content">
            {icon ? <div className="icon">{icon}</div> : null}
            <div>{title}</div>
          </div>
          <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <StyledLabel margin={'8px'} marginb={'20px'} style={{float:'unset'}}>Download a CSV of rewards activity based on your filters.</StyledLabel>
        <Border/>
  
      </div>

      <ConfirmPlanModalBody>

        {SelectPointTierLevels()}
      </ConfirmPlanModalBody>

      <Border/>
  
      <div className='footer'>
        <CommonButtonPopup height="48px" width="200px" disabled={!selectedDepartment || !selectedLocation || loading} onClick={() => postCompanyRewardTier()}>
        Download Report
        </CommonButtonPopup>
  
      </div>
    </StyledModal>
  )};


RewardReportModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  history:PropTypes.object,
  companyInfo:PropTypes.object,
  // departmentDetails:PropTypes.array,
  locationDetails:PropTypes.array
};

// const mapStateToProps = (state) => ({
//   departmentDetails: state.register.departmentDetails,
//   locationDetails: state.register.locationDetails,
// })

export default withRouter(connect(null , null)(withTranslation()(RewardReportModal)));
  
